export default __webpack_public_path__ + "static/media/iconTime.83859a43.svg";